import { Plus, TrendingUp } from "lucide-react-native";
import { Image, View } from "react-native";
import { ActionRowCard, SectionTitle } from "@louise/moon-ui";
import { EMBER } from "@louise/moon-ui/theme/tokens";
import monitoringIllustration from "@src/packages/moon-ui/assets/images/monitoring-dialog-illustration.png";
import { useTranslations } from "@src/packages/i18n";

export default function MonitoringEmptyStateCard({
  title,
  emptyTitle,
  subtitle,
  showSectionTitle = true,
  onAddData,
  marginTop = 24,
}: {
  title?: string;
  emptyTitle?: string;
  subtitle?: string;
  showSectionTitle?: boolean;
  onAddData?: () => void;
  marginTop?: number;
}) {
  const t = useTranslations();
  const resolvedTitle = title ?? t("care.response_chart.your_response");

  return (
    <View style={{ marginTop }}>
      {showSectionTitle ? (
        <View
          className="flex-row"
          style={{
            alignItems: "center",
            gap: 8,
            marginBottom: 10,
            paddingHorizontal: 2,
            flexWrap: "wrap",
          }}
        >
          <SectionTitle icon={TrendingUp}>{resolvedTitle}</SectionTitle>
        </View>
      ) : null}

      <View testID="monitoring-empty-state">
        <ActionRowCard
          leading={
            <View
              testID="monitoring-empty-illustration"
              style={{
                width: 38,
                height: 38,
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
              }}
            >
              <Image
                source={monitoringIllustration}
                resizeMode="contain"
                style={{ width: 58, height: 58 }}
              />
            </View>
          }
          title={emptyTitle ?? t("care.stim_sheet_view.no_monitoring_logged")}
          subtitle={
            subtitle ?? t("care.stim_sheet_view.monitoring_empty_prompt")
          }
          trailing={
            onAddData ? (
              <Plus
                size={18}
                color={EMBER.colors.textLight}
                strokeWidth={1.5}
              />
            ) : undefined
          }
          onPress={onAddData}
          action="care.response_chart.add_monitoring_data"
          accessibilityLabel={
            onAddData ? t("care.response_chart.add_monitoring_data") : undefined
          }
        />
      </View>
    </View>
  );
}
